import { Fragment } from 'react';
import { Link } from '@hc/redux-saga-router-plus';

import { Dialog } from 'legacy/components/Dialog';
import IconButton from 'legacy/components/generic/IconButton';
import ChartButton from 'legacy/components/ChartButton';

import MarketAnalysisSectionContainer from 'legacy/containers/market-analysis-section';

import { PropertyExplorerCharts as chartTheme } from 'legacy/css-modules';

import downloadIcon from 'legacy/assets/svg-inline/download-blue.svg';
import { capitalizeFirstLetter } from 'legacy/utils/strings';

const PropertyExplorerMarketAnalysisChartButton = ({
  chartModal,
  riskOfDeclineOneYear,
  riskOfDecline,
  onClose,
  msa,
  isExcelDownloadAllowed,
  isReportLoaded,
  handleClickDownloadSection,
  onClick
}) => {
  return (
    <Fragment>
      <Link
        options={{ inherit: true }}
        query={{ chartModal: 'marketChart' }}
        className={chartTheme.LinkButton}
        onClick={onClick}
      >
        <ChartButton title={'Market Analysis'}>
          <div className={chartTheme.ChartButtonText}>
            1y Risk of Decline:
            <b className={chartTheme.ChartButtonText}>
              {' '}
              {riskOfDeclineOneYear
                ? `${riskOfDeclineOneYear.toFixed(1)}%`
                : 'Not Enough Data'}{' '}
              (
              {riskOfDecline
                ? capitalizeFirstLetter(riskOfDecline)
                : 'Not Enough Data'}
              )
            </b>
          </div>
        </ChartButton>
      </Link>
      <Dialog
        active={chartModal === 'marketChart'}
        theme={chartTheme}
        title={
          <div className={chartTheme.DialogHeader}>
            Market Analysis {msa && `- ${msa.msaName}`}
            {isExcelDownloadAllowed && (
              <IconButton
                disabled={!isReportLoaded}
                onClick={handleClickDownloadSection}
                icon={downloadIcon}
                height="18px"
                width="18px"
                className={chartTheme.Icon}
              />
            )}
          </div>
        }
        onClose={onClose}
        closeButton
      >
        <MarketAnalysisSectionContainer />
      </Dialog>
    </Fragment>
  );
};

export default PropertyExplorerMarketAnalysisChartButton;
